import { ref } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';

export const useKaleidicalStore = defineStore('kaleidical', () => {
    const all = ref(null);

    const active = ref({});

    const isGuestAccessing = ref(false);

    const reset = () => {
        all.value = { data: [] };
    };

    const store = (params) => {
        return axios.post('/api/v1/kaleidicals', params);
    };

    const update = (params) => {
        return axios.patch(`/api/v1/kaleidicals/${params.hash}`, params);
    };

    const invite = (params) => {
        return axios.post(`/api/v1/kaleidicals/${params.hash}/invite`, params);
    };

    const accept = (params) => {
        return axios.post('/api/v1/accept', params);
    };

    const archive = (kaleidical) => {
        return axios.patch(`/api/v1/kaleidical/${kaleidical.hash}/archive`);
    };

    return {
        active,
        all,
        isGuestAccessing,
        reset,
        store,
        invite,
        accept,
        update,
        archive,
    };
});
